export default [{
    title: 'Usuarios',
    icon: 'UsersIcon',
    children: [
        {
            title: 'Lista',
            route: 'users-list',
            action: 'read',
		    resource: 'users'
        }, 
        {
            title: 'Nuevo',
            route: 'users-create',
            action: 'create',
		    resource: 'users'
        }
    ]
}];